import { base as r, baseError as o, inputText as e, size as t, baseTextArea as i, sizeTextArea as m } from "./base.mjs";
import { container as p } from "./container.mjs";
import { hint as a, hintError as n } from "./hint.mjs";
import { hover as s, focus as f } from "./interactions.mjs";
import { label as b, labelError as c } from "./label.mjs";
const T = {
  base: r,
  baseError: o,
  inputText: e,
  container: p,
  label: b,
  labelError: c,
  hint: a,
  hintError: n,
  size: t,
  hover: s,
  focus: f,
  baseTextArea: i,
  sizeTextArea: m
};
export {
  T as inputRecipe
};
